import { Alert, Box, Divider, LinearProgress, Typography } from '@mui/material'
import type { PrizeToImport } from 'types/Prize'

export const PrizesSummary = ({ prizes, colors }: { prizes: PrizeToImport[]; colors: string[] }): JSX.Element => {
  return (
    <Box>
      <Typography variant="h6" component="h3" fontWeight={600}>
        Prize stock summary
      </Typography>
      <Divider sx={{ my: 1 }} />
      {prizes.map((prize, idx) => {
        const progress = Math.round((prize.amountLeft / prize.totalAmount) * 10000) / 100
        const color = colors[(idx + colors.length) % colors.length]
        const alphaColor = `${color}11`

        return (
          <Alert
            icon={false}
            key={prize.name}
            sx={{
              mb: 2,
              width: '100%',
              backgroundColor: alphaColor,
              '& .MuiAlert-message': {
                width: '100%',
              },
            }}
          >
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight={500} sx={{ color }} variant="body2">
                {prize.name}
              </Typography>
              <Typography fontWeight={400} sx={{ color }} variant="caption">
                {progress}% left
              </Typography>
            </Box>
            <LinearProgress
              sx={{
                width: '100%',
                borderRadius: 8,
                height: 8,
                backgroundColor: alphaColor,
                '& .MuiLinearProgress-bar': {
                  backgroundColor: color, // kolor postępu
                  borderRadius: 8,
                },
              }}
              variant="determinate"
              value={progress}
            />
          </Alert>
        )
      })}
    </Box>
  )
}
